// extracted by mini-css-extract-plugin
module.exports = {"FoodCourtLayout":"FoodCourtLayout_FoodCourtLayout__1jZpJ","foodcourtLeft":"FoodCourtLayout_foodcourtLeft__32y_G","foodcourtRight":"FoodCourtLayout_foodcourtRight__PzCJW"};